import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import TarotReadingTeeup from './tarot-reading/teeup';
import TarotReadingSampleInterp from './tarot-reading/sample-interp';

class Component extends BaseComponent {
    componentWillMount() {
        const bgImg = 'background-image: url(https://gfx.tarot.com/images/site/tarot/' + this.props.upc;
        const styleSheet = document.createElement('style');
        const styleRules = [
            'tarot-reading .icon-teeup { ' + bgImg + '/icon.svg); }',
            'tarot-reading-deck-card { ' + bgImg + '/card-back.svg); }',
            'tarot-reading-deck-card:hover { ' + bgImg + '/card-back-highlight.svg); }',
            'tarot-reading-deck-card.shuffle { ' + bgImg + '/card-back-highlight.svg); }',
            'tarot-spread .outline { ' + bgImg + '/question-grey.svg); }',
            'tarot-spread spread-card.next .outline { ' + bgImg + '/question-highlight.svg); }',
        ];

        styleRules.forEach((rule) => {
            styleSheet.appendChild(document.createTextNode(rule));
        });

        document.head.appendChild(styleSheet);

        this.props.init(this.props.upc, this.props.type);
        let deck_name = 'universal_waite';

        if (this.props.upc.match(/mandala/)) {
            deck_name = 'mandala';
        } else {
            if (this.props.user.logged_in && this.props.user.favorite_deck_id && this.props.decks) {
                const deck = this.props.decks.filter(deck => {
                    return deck.deck == this.props.user.favorite_deck_id;
                });

                if (deck && deck[0] && deck[0].deck) {
                    deck_name = deck[0].deck;
                }
            }
        }

        this.props.requireDeck(deck_name);
    }

    render({ type, upc }) {
        let view = null;

        if (upc == 'yes-or-no-tarot-redux') {
            view = 'view-1';

            if (this.props.spread && this.props.spread.length == 8) {
                view = 'view-2';
            }
        }

        return (
            <tarot-reading class={type} upc={upc} type={type} onclick={(e) => this.trackClick(e)} view={view}>
                {this.renderReadingOrInterp()}
            </tarot-reading>
        );
    }

    renderReadingOrInterp() {
        if (this.props.sample_interps) {
            return (
                <TarotReadingSampleInterp type={this.props.type} />
            );
        }

        return (
            <TarotReadingTeeup upc={this.props.upc} type={this.props.type} />
        );
    }

    trackClick = (e) => {
        if (e.target.dataset.action) {
            this.props.trackEvent(e.target.dataset.action);
        }
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    deck: state.deck,
    decks: state.decks,
    spread: state.deck && state.deck.spread,
    sample_interps: state['tarot-reading'].interps,
});

const mapDispatchToProps = (dispatch) => ({
    init: (upc, type) => dispatch({ type: 'tarot-reading:init', payload: { upc: upc, type: type} }),
    requireDeck: (deck) => dispatch({ type: 'deck:required', payload: deck }),
    trackEvent: (action) => dispatch({ type: 'tarot-ga:event', payload: action }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/tarot-reading.js